const OrderStatus = Object.freeze({
  PENDING: 'pending',
  REQUESTED: 'requested',
  RETURNED: 'returned'
})

export default OrderStatus